"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _mediaTools = require("@evideo/media-tools");

var _vue = require("vue");

var __awaiter = void 0 && (void 0).__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var _default = function _default(workerPublicPath) {
  var mediaGeneratorTools = [];
  var tempoPitchCache = new Map();
  var tempoPitchTask = (0, _vue.ref)();
  var tempoPitchTaskResult = (0, _vue.ref)([]);
  var tempoPitchIng = (0, _vue.ref)(false);
  var tempoPitchTotalProgress = (0, _vue.ref)({});
  var tempoPitchProgress = (0, _vue.computed)(function () {
    var pValues = Object.values(tempoPitchTotalProgress.value);
    var totalP = pValues.reduce(function (total, item) {
      total += item;
      return total;
    }, 0);
    return totalP / pValues.length;
  });
  /**
   * 获取MediaGeneratorTool
   * @returns
   */

  var getMediaGeneratorTool = function getMediaGeneratorTool() {
    var mediaGeneratorTool = mediaGeneratorTools.find(function (item) {
      return !item.isOccupy;
    });

    if (mediaGeneratorTool) {
      mediaGeneratorTool.isOccupy = true;
      return mediaGeneratorTool;
    }

    console.info('new MediaGenerator');

    var tool = _mediaTools.MediaGenerator.getMediaGenerator(workerPublicPath ? {
      log: true,
      pathPrefix: workerPublicPath
    } : {
      log: true
    });

    mediaGeneratorTool = {
      tool: tool,
      isOccupy: true,
      isRunning: false
    };
    mediaGeneratorTools.push(mediaGeneratorTool);
    return mediaGeneratorTool;
  };
  /**
   * 变速变调
   * @param options
   */


  var handleMultiTempoAndPitch = function handleMultiTempoAndPitch(options) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var handles;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(options.length <= 0)) {
                _context.next = 2;
                break;
              }

              throw new Error(' handleMultiTempoAndPitch options is empty');

            case 2:
              resetMultiTempoAndPitch();
              handles = options.map(function (option) {
                return new Promise(function (resolve, reject) {
                  handleSingleTempoAndPitch(option.buffer, option.url, option.pitch, option.tempo, function (_, ratio) {
                    tempoPitchTotalProgress.value[option.url] = ratio;
                  }).then(function (url) {
                    resolve({
                      name: option.name,
                      url: url
                    });
                  }).catch(reject);
                });
              }); //

              tempoPitchIng.value = true;
              tempoPitchTotalProgress.value = {};
              tempoPitchTask.value = Promise.all(handles).then(function (urls) {
                setTimeout(function () {
                  tempoPitchIng.value = false;
                }, 100);
                tempoPitchTaskResult.value = urls;
                return urls;
              });

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  };
  /**
   * 等待变速变调完
   * @returns
   */


  var awaitHandleMultiTempoAndPitch = function awaitHandleMultiTempoAndPitch() {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      var urls;
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (tempoPitchIng.value) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return", tempoPitchTaskResult.value);

            case 2:
              _context2.prev = 2;
              _context2.next = 5;
              return tempoPitchTask.value;

            case 5:
              urls = _context2.sent;
              tempoPitchIng.value = false;
              tempoPitchTask.value = new Promise(function () {});
              return _context2.abrupt("return", urls);

            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](2);
              throw _context2.t0;

            case 14:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[2, 11]]);
    }));
  };

  var resetMultiTempoAndPitch = function resetMultiTempoAndPitch() {
    while (tempoPitchTaskResult.value.length > 0) {
      var result = tempoPitchTaskResult.value.pop();
      result && URL.revokeObjectURL(result.url);
      result = undefined;
    }

    tempoPitchIng.value = false;
    tempoPitchTask.value = new Promise(function () {});
    tempoPitchTotalProgress.value = {};
  };
  /**
   * 单个音频的变速变调
   * @param buffer
   * @param url
   * @param pitch
   * @param tempo
   * @returns
   */


  var handleSingleTempoAndPitch = function handleSingleTempoAndPitch(buffer, url) {
    var pitch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var tempo = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
    var progress = arguments.length > 4 ? arguments[4] : undefined;
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee3() {
      var key, existentBlob, blob, tool, result, _url;

      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!(!buffer || buffer.byteLength === 0)) {
                _context3.next = 3;
                break;
              }

              console.log('handleTempoAndPitch buffer is empty or undefined');
              return _context3.abrupt("return");

            case 3:
              key = "".concat(url, "_").concat(pitch, "_").concat(tempo);
              existentBlob = tempoPitchCache.get(key);

              if (!existentBlob) {
                _context3.next = 7;
                break;
              }

              return _context3.abrupt("return", window.URL.createObjectURL(existentBlob));

            case 7:
              blob = new Blob([buffer], {
                type: 'audio/mp3'
              });

              if (!(tempo == 1 && pitch == 0)) {
                _context3.next = 10;
                break;
              }

              return _context3.abrupt("return", window.URL.createObjectURL(blob));

            case 10:
              tool = getMediaGeneratorTool();
              tool.isRunning = true;
              _context3.prev = 12;
              tool.tool.setProgress(function (detail) {
                progress && progress(detail.time, detail.ratio);
              });
              _context3.next = 16;
              return tool.tool.changeTempoAndPitch({
                data: blob,
                type: 'audio'
              }, {
                tempo: tempo,
                pitch: pitch
              });

            case 16:
              result = _context3.sent;

              if (!result) {
                _context3.next = 23;
                break;
              }

              _url = window.URL.createObjectURL(result);
              console.log("handleTempoAndPitch success , tempo:".concat(tempo, ",pitch:").concat(pitch));
              tempoPitchCache.set(key, result); // !只保留最近10个变速的音频，保证内存不会一直增加

              if (tempoPitchCache.size > 10) {
                tempoPitchCache.delete(tempoPitchCache.keys().next().value);
              }

              return _context3.abrupt("return", _url);

            case 23:
              _context3.next = 28;
              break;

            case 25:
              _context3.prev = 25;
              _context3.t0 = _context3["catch"](12);
              return _context3.abrupt("return");

            case 28:
              _context3.prev = 28;
              tool.isOccupy = false;
              tool.isRunning = false;
              return _context3.finish(28);

            case 32:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[12, 25, 28, 32]]);
    }));
  };
  /**
   * 销毁转码工具
   */


  var destroyMediaGenerator = function destroyMediaGenerator() {
    while (mediaGeneratorTools.length > 0) {
      var mediaGenerator = mediaGeneratorTools.pop();

      if (mediaGenerator === null || mediaGenerator === void 0 ? void 0 : mediaGenerator.tool) {
        mediaGenerator.tool.close();
        mediaGenerator.tool = null;
      }

      mediaGenerator = undefined;
    }
  };
  /**
   * 清除转码缓存
   */


  var clearTempoPitchCache = function clearTempoPitchCache() {
    tempoPitchCache.clear();
  };
  /**
   * 清除转码内容
   */


  var clearMultiTempoAndPitch = function clearMultiTempoAndPitch() {
    clearTempoPitchCache();
    destroyMediaGenerator();
    tempoPitchTotalProgress.value = {};
    tempoPitchIng.value = false;
    tempoPitchTask.value = undefined;
  };

  return {
    tempoPitchTask: tempoPitchTask,
    tempoPitchIng: tempoPitchIng,
    tempoPitchProgress: tempoPitchProgress,
    handleMultiTempoAndPitch: handleMultiTempoAndPitch,
    awaitHandleMultiTempoAndPitch: awaitHandleMultiTempoAndPitch,
    clearMultiTempoAndPitch: clearMultiTempoAndPitch,
    resetMultiTempoAndPitch: resetMultiTempoAndPitch
  };
};

exports.default = _default;